import { LoadingStatusType } from "@/enums/enums";
import API from "@/service/Index";
import { Action, Module, Mutation, VuexModule } from "vuex-module-decorators";
import store from "..";

@Module({ namespaced: true })
export default class Package extends VuexModule {
  private packageDetail: any | null = null;
  private packageDetailLoadingStatus: LoadingStatusType = LoadingStatusType.None;

  get getPackageDetail(): any {
    return this.packageDetail;
  }

  get getPackageDetailLoadingStatus(): LoadingStatusType {
    return this.packageDetailLoadingStatus;
  }

  @Mutation
  public SetPackageDetail(packageDetail: any) {
    this.packageDetail = packageDetail;
  }

  @Mutation
  public SetPackageDetailLoadingStatus(status: LoadingStatusType) {
    this.packageDetailLoadingStatus = status;
  }

  @Action
  public DoGetPackageDetail() {
    if (this.packageDetailLoadingStatus !== LoadingStatusType.Loading) {
      this.context.commit("SetPackageDetailLoadingStatus", LoadingStatusType.Loading);
      this.context.dispatch("Loading/IsLoading", true, { root: true });
      API.PackageService.DoGetPackageDetail().then((res: any) => {
        if (res.data.responseCode.IsSuccess()) {
          this.context.commit("SetPackageDetail", res.data.package);
        }
        this.context.commit("SetPackageDetailLoadingStatus", LoadingStatusType.Success);
        this.context.dispatch("Loading/IsLoading", false, { root: true });
      });
    }
  }
}
